<template>
    <div id="app">
        <div v-if="!isUser">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Access Denied!</h4>
                <p>You do not have the necessary permissions to access this application.</p>
                <hr>
                <p class="mb-0">Please contact the IT Helpdesk: <a href="mailto:it.helpdesk@taurus.gi">it.helpdesk@taurus.gi</a></p>
            </div>
        </div>
        <div v-else>
            <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
                <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="/dashboard">Taurus Insurance Services</a>
                <quick-search_input v-on:quick-search-enter="quickSearch" />
                <ul class="navbar-nav px-3">
                    <li class="nav-item text-nowrap">
                        <a class="nav-link" href="javascript:void(0)" @click="logOut()">Sign out</a>
                    </li>
                </ul>
            </nav>

            <div class="container-fluid">
                <transition name="fade">
                    <div v-if="showSidebar == true" class="row">
                        <side-bar v-on:toggle-clicked="sidebarToggleClicked" />

                        <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4">
                            <router-view :key="$route.fullPath" />
                        </main>
                    </div>
                    <div v-else class="row">
                        <div v-if="!isPopout" class="sidebar bg-light" style="width:20px">
                            <i :class="showSidebarIcon" @click="manShowSidebar = !manShowSidebar" v-b-tooltip.hover.right title="Show menu"></i>
                        </div>
                        <main role="main" class="col-md-12 ml-sm-auto col-lg-12 px-4">
                            <router-view :key="$route.fullPath" />
                        </main>
                    </div>
                </transition>
            </div>
        </div>
        <toast />
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>
    import Sidebar from '@/components/Sidebar.vue'
    import authentication from '@/util/authentication'
    import Toast from '@/components/toast.vue'

    import QuickSearch from "@/components/QuickSearch.vue"
    import quickSearch from "@/mixins/quickSearch.js"
    import Loading from 'vue-loading-overlay';

    export default {
        components: {
            'side-bar': Sidebar,
            'toast': Toast,
            "quick-search_input": QuickSearch,
            "loading": Loading
        },
        mixins: [
            quickSearch,
        ],
        data: () => {
            return {
                manShowSidebar: true
            }
        },
        beforeCreate() {
            this.$store.commit('initialise')
            this.$store.dispatch('appSettings/fetchClaimPaymentsEnabled')
            this.$store.dispatch('appSettings/fetchRunPipelinesEnabled')
        },
        computed: {
            showSidebar() {
                return this.$route.query.sidebar ? this.$route.query.sidebar : this.manShowSidebar; //show sidebar by default
            },
            showSidebarIcon() {
                if (this.manShowSidebar) {
                    return 'fas fa-angle-double-left'
                } else {
                    return 'fas fa-angle-double-right'
                }
            },
            isPopout() {
                return this.$route.query.sidebar ? this.$route.query.sidebar : false
            },
            isUser() {
                return this.$adminUser.isUser()
            }
        },
        methods:
        {
            logOut() {
                authentication.signOut();
            },
            sidebarToggleClicked(val) {
                this.manShowSidebar = val[0]
            },
            async quickSearch(ev) {
                console.log("-qs: ", ev);
                const payload = {
                    claimReference: ev
                }
                console.log("-p: ", payload);
                await this.handleSearchClickEx(payload);
            }
        }
    }

</script>

<style>
    .sidebarmin {

    }
</style>
